import { FC } from 'react';
import useHome from '@/hooks/use-home.hook';
import TileGroup from '@/components/tile-group';
import TileGroupHeader from '@/components/tile-group/header';
import TileContent from '@/components/tile-group/content';
import EmptyTile from '@/components/tile-group/empty-tile';
import { TILE_COMPONENTS } from '@/components/tile-group/tile/helpers';

const FavoritesTileGroup: FC = () => {
  const { recent } = useHome();
  const showEmptyTile = !recent.length;

  return (
    <TileGroup>
      <TileGroupHeader title="Recent" icon="history" />
      <TileContent>
        {recent.map((tile) => {
          const TileEl = TILE_COMPONENTS[tile.tileType];

          if (TileEl) {
            return <TileEl key={tile.tileId} tile={tile} />;
          }
        })}
        {showEmptyTile && <EmptyTile />}
      </TileContent>
    </TileGroup>
  );
};

export default FavoritesTileGroup;
